<template>
<div v-if="!refreshPage">
  <div v-if="services.length > 0" class="product-create-form">
    <div class="pcf-row">
      <h2>Product Names</h2>
      <input type="text"  v-model="name" class="al-input" placeholder="Enter name here..." />
    </div>
    <div class="pcf-row">
      <h2>Initial Price</h2>
      <input class="ef-input" v-model="initialPrice" type="number" min="1" step="any" name="Price" v-validate="'required'"  :placeholder="`$${getTotalSelectedPrice}`">
    </div>
    <div class="pcf-divider"></div>
    <div class="pcf-row">
      <h2>Add Features</h2>
      <div class="pcf-feature-area" v-if="services.length > 0">
        <div class="pcf-feature" @click="showPopup = true"> Add or Remove</div>
        <div class="pcf-feature"
             v-if="serviceValid(service_id)"
             v-for="service_id in selected_services" :key="service_id">
          {{ services.filter(service => service._id === service_id)[0].name }}
        </div>
      </div>
    </div>
    <div class="pcf-divider"></div>
    <div class="pcf-row">
      <h2>Edit Pricing</h2>
      <div class="pcf-price-edit-area" v-if="services.length > 0">
        <div class="pcf-price-item" v-for="service_id in selected_services"
             v-if="serviceValid(service_id)" :key="service_id">
          <div class="pcf-item-name">{{ services.filter(service => service._id === service_id)[0].name }}</div>
          <div class="pcf-item-price">${{ services.filter(service => service._id === service_id)[0].price / 100 }}</div>
        </div>
        <div class="pcf-price-total">
          <div class="pcf-item-name">TOTAL</div>
          <div class="pcf-item-price">

            <input class="ef-input" v-model="price" type="number" min="1" step="any" name="Price" v-validate="'required'" >
            <span class="text-danger text-sm" v-show="errors.has('Price')">{{ errors.first('Price') }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="pcf-divider"></div>
    <div class="pcf-row">
      <h2>Renewal Frequency</h2>
      <div class="pcf-feature-area">
        <v-select name="user_group"
                  class="ef-input border-none"
                  v-model="freq"
                  :options="freq_options" :clearable="false"></v-select>
      </div>
    </div>
    <div class="pcf-divider"></div>
    <div class="pcf-row">
    <h2>Assign Product</h2>
    <div class="pcf-assign">
      <div>Assign this plan to: </div>
      <div>
        <select v-model="selectedUser">
          <option selected :value="-1">Choose a Client...</option>
          <option :value="user._id" :key="user._id" v-for="user in users">{{ user.company ? user.company.name : user.name }}</option>
        </select>
      </div>
    </div>
    <div class="pcf-assign">
      <div class="al-button blue-button" @click="saveClick">Save Product</div>
    </div>

  </div>
  </div>
  <div v-else>
    Please add a service first
  </div>
  <select-service-popup v-if="showPopup && services.length > 0"
                        :updated="selected_services_updated" :services="services" />
</div>
</template>

<script>
import vSelect from 'vue-select'
import SelectServicePopup from './SelectServicePopup'
export default {
  name: 'CreateBundle',
  components: {
    SelectServicePopup,
    vSelect
  },
  data () {
    return {
      name: '',
      price: 0,
      initialPrice: 0,
      selectedUser: -1,
      services: [],
      users: [],
      freq: {label: 'Monthly', value: 'monthly'},
      freq_options: [
        {label: 'Daily', value: 'daily'},
        {label: 'Weekly', value:'weekly'},
        {label: 'Monthly', value:'monthly'},
        {label: 'Yearly', value:'yearly'},
        {label: 'One time', value:'onetime'}
      ],
      refreshPage: false,
      showPopup: false,
      editingProduct: null
    }
  },
  mounted () {
    this.getServiceList()
    this.getUserList()
  },
  watch: {
    refreshPage () {
      if (this.refreshPage) {
        setTimeout(() => {
          this.refreshPage = false
        }, 500)
      }
    },
    '$store.state.selected_services' () {
      console.log('services changed', this.selected_services)
    }
  },
  computed: {
    getTotalSelectedPrice () {
      let total = 0
      this.selected_services.map(service_id => {
        const service = this.services.filter(serv => serv._id === service_id)[0]
        if (service) {
          total += service.price / 100
        }
      })
      return total.toFixed(2)
    },
    selected_services () {
      return this.$store.state.selected_services
    }
  },
  methods: {
    serviceValid (service_id) {
      const result = this.services.filter(service => service._id === service_id).length > 0
      //console.log('service valid', result, this.services, service_id)
      return  result
    },
    saveClick () {
      if (this.editingProduct) {
        this.patchBundle()
      } else {
        this.saveBundle()
      }
    },
    clearData () {
      this.name = ''
      this.initialPrice = 0
      this.price = 0
      this.selectedUser = -1
      this.selected_services_updated([])
    },
    editBundle (data) {
      const initData = JSON.parse(JSON.stringify(data))
      const { name, price, initialPrice, services, customer, freq } = initData
      this.editingProduct = initData

      this.name = name
      this.price = price / 100
      this.initialPrice = initialPrice

      this.freq = this.freq_options.filter(freq_ => freq_.value === freq)[0]

      if (customer) {
        this.selectedUser = customer
      }
      if (services) {
        if (services.length > 0) {
          this.selected_services_updated(services)
        }
      }
    },
    selected_services_updated (selected_services) {
      console.log('setting selected services', selected_services)
      this.$store.commit('SET_SELECTED_SERVICES', selected_services)
      this.refreshPage = true
      this.showPopup = false
    },
    getServiceList () {
      this.$vs.loading()
      const payload = {
        page: 0
      }
      this.$store.dispatch('getServiceList', payload)
        .then(response => {
          console.log('response services', response)
          this.services = response.data

          if (this.price === 0) {
            this.price = this.getTotalSelectedPrice
          }
          console.log('set initial price', this.initialPrice)
          this.$vs.loading.close()
        })
        .catch(err => {
          console.error(err)
        })
    },
    getUserList () {
      const payload = {
        page: 0
      }
      this.$store.dispatch('getUserList', payload)
        .then(response => {
          console.log('getUserList response', response)
          this.users = response.data
        })
        .catch(err => {
          console.error(err)
        })
    },
    saveBundle () {
      this.$validator.validateAll().then(result => {
        if (result) {

          this.$vs.loading()
          const payload = {
            name: this.name,
            price: Number.parseFloat(this.price) * 100,
            initialPrice: Number.parseFloat(this.initialPrice),
            freq: this.freq.value,
            services: this.selected_services
          }
          if (this.selectedUser !== -1) {
            payload.customer = this.selectedUser
          }
          this.$store.dispatch('saveBundle', payload)
            .then(response => {
              console.log('response', response)
              this.$vs.loading.close()
              this.clearData()
              this.$parent.activeTab = 0
            })
            .catch(err => {
              console.error(err)
            })

        }
      })
    },
    patchBundle () {
      this.$validator.validateAll().then(result => {
        if (result) {

          this.$vs.loading()
          const payload = {
            _id: this.editingProduct._id,
            name: this.name,
            price: Number.parseFloat(this.price) * 100,
            initialPrice: Number.parseFloat(this.initialPrice),
            services: this.selected_services,
            freq: this.freq.value
          }
          if (this.selectedUser !== -1) {
            payload.customer = this.selectedUser
          }
          this.$store.dispatch('patchBundle', payload)
            .then(response => {
              console.log('response', response)
              this.$vs.loading.close()
              this.clearData()
              this.$parent.activeTab = 0
            })
            .catch(err => {
              console.error(err)
            })

        }
      })
    }
  }
}
</script>

<style scoped>

</style>
